import {
  API_BASE_URL,
  API_REQUEST
} from 'core/api';


import { LOGIN_TYPES, LOGIN_RESET } from './action-types';

export function login(username, password) {
  const grantType = 'password';

  return {
    [API_REQUEST]: {
      types: LOGIN_TYPES,
      config: {
        data: { username, password, grantType },
        method: 'post',
        url: `${API_BASE_URL}/jwt/token`
      }
    }
  };
}

/**
 * Función que se encarga de inicializar el state.
 */
export function loginReset() {
  return {
    type: LOGIN_RESET
  };
}


// WEBPACK FOOTER //
// ./src/core/services/login/action-creators.js